/* eslint-disable no-param-reassign */
import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import {type IestadoUsuario} from '@api/types/auth';
import { MenuItemLateral } from 'src/layouts/layout-privado/sidebar/Sidebar';
import { Irol } from 'src/utils/roles/roles';
import { ItemMenu } from 'src/utils/menu/menus';

export const initialState: IestadoUsuario = {
	usuario: undefined,
	token: undefined,
	menu: [],
	menuLateral: [],
	rolActivo: undefined,
};

/**
 * Slice de Redux para el manejo de la información del usuario
 * @see https://redux-toolkit.js.org/api/createSlice
 *
 */
export const usuarioSlice = createSlice({
	initialState,
	name: 'usuarioSlice',
	reducers: {
		logout: () => initialState,
		setUsuario: (state, action: PayloadAction<IestadoUsuario>) => {
			state.usuario = action.payload.usuario;
			state.token = action.payload.token;
			state.menu = action.payload.menu;
			state.menuLateral = action.payload.menuLateral;
			state.rolActivo = action.payload.rolActivo;

		},
		setMenuLateral: (state, action: PayloadAction<MenuItemLateral[]>) => {
			state.menuLateral = action.payload;
		},
		setMenu: (state, action: PayloadAction<ItemMenu[]>) => {
			state.menu = action.payload;
		},
		setRolActivo: (state, action: PayloadAction<Irol>) => {
				state.rolActivo = action.payload;
		}
	},
});

export default usuarioSlice.reducer;

export const {
	logout, setUsuario, setMenuLateral, setRolActivo, setMenu
} = usuarioSlice.actions;
